import { SET_MSAL } from "../constanst";

const initialState = {
    msalInstance: "Holii",
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_MSAL:
            return {
                msalInstance: action.payload
            }
        default:
            return state;
    }
}